#import "../../../../../list/TravelSectionAuthDataFragment.graphql"

mutation TravelAuthorizationCopy($input: TravelAuthorizationCopyInput!) {
  travelAuthorizationCopy(input: $input) {
    newTravelAuthorization {
      __typename
      id
      _urgencyLevel
      _isCorporateTravelAuthorization
      _isOverBudget
      _travelerReference
      _rowTimestamp
      _isUpdatable
      _isDeletable
      travelAuthorizationNumber
      comment
      _suppliers
      tripPurpose
      travelAuthorizationDate
      department {
        name
      }
      businessUnit {
        name
      }
      currency {
        isoCode
        name
        currencySymbol
      }
      corporateWorkgroupName
      budgetAmount
      controlTotalAmount
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _pendingApprovers
      _isStagedApprovalRequest
      _isApprovalRevocable
      ...TravelAuthorizationTravelSectionFragment
      _isAccountingEntryStampedComplete
      _isAccountingEntry
      _accountingStampTransactionReference
      _createdDate
      _createdByUserName
    }
  }
}
